import { render, staticRenderFns } from "./RappProdProcResum.vue?vue&type=template&id=5f0b443c&scoped=true&"
import script from "./RappProdProcResum.vue?vue&type=script&lang=js&"
export * from "./RappProdProcResum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b443c",
  null
  
)

export default component.exports